"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const rescale = (x, oldMin, oldMax, newMin, newMax) => {
  return (newMax - newMin) / (oldMax - oldMin) * (x - oldMin) + newMin;
};
var _default = exports.default = rescale;